import {
  Component,
  EventEmitter,
  forwardRef,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { JobseekerEducationModel } from '../shared/models/jobseeker-education-model';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-jobseeker-education-filter',
  templateUrl: './jobseeker-education-filter.component.html',
  styleUrls: ['./jobseeker-education-filter.component.less'],
  standalone: false,
})
export class JobseekerEducationFilterComponent {
  @Input() educationLevelList: any[]; //BasicOptionItem[];
  @Input() educationalInstitutionList: JobseekerEducationModel[];
  @Input() educationalProgramList: any[]; // EducationalProgram[];

  @Input() educationLevel: number;
  @Input() institutions: number[];
  @Input() programs: number[];

  @Output() selectEducationLevels: EventEmitter<number> =
    new EventEmitter<number>();
  @Output() selectInstitutions: EventEmitter<number[]> = new EventEmitter<
    number[]
  >();
  @Output() selectPrograms: EventEmitter<number[]> = new EventEmitter<
    number[]
  >();

  constructor() {}

  onSelectEducationLevels(val) {
    this.selectEducationLevels.emit(val.value);
  }

  onSelectInstitutions(event) {
    this.selectInstitutions.emit(event.value);
  }

  onSelectPrograms(event) {
    this.selectPrograms.emit(event.value);
  }
}
